import axios from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function storeProgramSponsorJob (pFormdata) {
    const URI = `${BASE_URL}/api/programSponsorJobs`
    return axios.post(URI, pFormdata, { headers })
}

function updateProgramSponsorJob (pFormdata, pIdProgramSponsorJob) {
    const URI = `${BASE_URL}/api/programSponsorJobs/${pIdProgramSponsorJob}`
    return axios.post(URI, pFormdata, { headers })
}

function destroyProgramSponsorJob (pIdProgramSponsorJob) {
    const URI = `${BASE_URL}/api/programSponsorJobs/${pIdProgramSponsorJob}`
    return axios.delete(URI,{ headers })
}
export { 
    storeProgramSponsorJob,
    updateProgramSponsorJob,
    destroyProgramSponsorJob
 }